var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as GamesAction from "../../actions/games";
import * as SignOutAction from "../../actions/auth/SignOut";
var initialState = {
    games: {
        isLoading: false,
        error: null,
        data: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: window.innerWidth < 768 ? 12 : 24,
            Items: [],
        },
        isTop: null,
        hasGames: true,
    },
    randomGames: {
        isLoading: false,
        error: null,
        data: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: 50,
            Items: [],
        },
    },
    gamesByProvider: {
        isLoading: false,
        error: null,
        data: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: window.innerWidth < 768 ? 12 : 24,
            Items: [],
        },
    },
    gamesFilter: {
        showModal: false,
        types: null,
        providers: null,
        isLoading: false,
        error: null,
        selectedTypes: new Map(),
        selectedProviders: new Map(),
        filterConflict: false,
        providerSortType: 0,
        searchedGames: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: 0,
            Items: null,
        },
    },
    lobbyGames: {
        isLoading: false,
        topGames: null,
        gameTypes: null,
        error: null,
    },
    moreGames: {
        isLoading: false,
        error: null,
        games: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: 0,
            Items: null,
        },
    },
    allGames: {
        isLoading: false,
        error: null,
        games: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: 0,
            Items: null,
        },
    },
    orderedGames: {
        isLoading: false,
        error: null,
        groups: null,
        mode: null,
    },
    recentGames: {
        error: null,
        isLoading: false,
        games: {
            TotalCount: 0,
            Count: 0,
            Offset: 0,
            Limit: 0,
            Items: null,
        },
    },
    recentVisitedGames: {
        isLoading: false,
        error: null,
        games: {
            Items: null,
        },
    },
    openGame: {
        isLoading: false,
        error: null
    }
};
export default function balance(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case GamesAction.CLEAR_GET_GAMES:
            return __assign(__assign({}, state), { games: __assign(__assign({}, initialState.games), { isTop: state.games.isTop }) });
        case GamesAction.CLEAR_RANDOM_GAMES:
            return __assign(__assign({}, state), { randomGames: __assign({}, initialState.randomGames) });
        case GamesAction.GET_GAMES:
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { isLoading: true, hasGames: true }) });
        case GamesAction.SUCCESS_GET_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { isLoading: false, data: __assign(__assign({}, action.data), { Items: action.data.Offset === 0
                            ? (action.data.Items || [])
                            : __spreadArray(__spreadArray([], state.games.data.Items, true), (action.data.Items || []), true) }), error: null, hasGames: !!(action.data.Items || []).length }) });
        case GamesAction.FAILURE_GET_GAMES:
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { isLoading: false, hasGames: false, error: action.data }) });
        case GamesAction.FETCH_RANDOM_GAMES:
            return __assign(__assign({}, state), { randomGames: __assign(__assign({}, state.randomGames), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_RANDOM_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { randomGames: __assign(__assign({}, state.randomGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { randomGames: __assign(__assign({}, state.randomGames), { isLoading: false, data: __assign(__assign({}, action.data), { Items: action.data.Offset === 0
                            ? action.data.Items || []
                            : __spreadArray(__spreadArray([], (state.randomGames.data.Items || []), true), (action.data.Items || []), true) }), error: null }) });
        case GamesAction.FAILURE_FETCH_RANDOM_GAMES:
            return __assign(__assign({}, state), { randomGames: __assign(__assign({}, state.randomGames), { isLoading: false, error: action.data }) });
        case GamesAction.SET_IS_TOP_GAMES:
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { isTop: action.data }) });
        case SignOutAction.SIGNOUT:
            return initialState;
        case GamesAction.FETCH_LOBBY_GAMES:
            return __assign(__assign({}, state), { lobbyGames: __assign(__assign({}, state.lobbyGames), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_LOBBY_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { lobbyGames: __assign(__assign({}, state.lobbyGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { lobbyGames: {
                    isLoading: false,
                    topGames: action.data.TopGames,
                    gameTypes: action.data.GameTypes,
                    error: null,
                } });
        case GamesAction.FAILURE_FETCH_LOBBY_GAMES:
            return __assign(__assign({}, state), { lobbyGames: __assign(__assign({}, state.lobbyGames), { isLoading: false, error: action.data }) });
        case GamesAction.FETCH_MORE_GAMES:
            return __assign(__assign({}, state), { moreGames: __assign(__assign({}, state.moreGames), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_MORE_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { moreGames: __assign(__assign({}, state.moreGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { moreGames: {
                    isLoading: false,
                    games: action.data,
                    error: null,
                } });
        case GamesAction.FAILURE_FETCH_MORE_GAMES:
            return __assign(__assign({}, state), { moreGames: __assign(__assign({}, state.moreGames), { isLoading: false, error: action.data }) });
        case GamesAction.FETCH_FILTER_TYPES:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_FILTER_TYPES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, types: action.data.Items, error: null }) });
        case GamesAction.FAILURE_FETCH_FILTER_TYPES:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data }) });
        case GamesAction.FETCH_FILTER_PROVIDERS:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_FILTER_PROVIDERS:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, providers: action.data.Items, error: null }) });
        case GamesAction.FAILURE_FETCH_FILTER_PROVIDERS:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data }) });
        case GamesAction.SHOW_GAMES_FILTER_MODAL:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { showModal: action.payload }) });
        case GamesAction.HANDLE_SELECT_FILTER_OPTION: {
            var _c = action.payload, option = _c.option, fieldName = _c.fieldName;
            var currentField = new Map(state.gamesFilter[fieldName]);
            var oppositeFieldName = fieldName === "selectedProviders" ? "selectedTypes" : "selectedProviders";
            var oppositeField = state.gamesFilter[oppositeFieldName];
            var isRemoving = currentField.has(option.Id);
            if (isRemoving) {
                currentField.delete(option.Id);
                return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), (_a = {}, _a[fieldName] = currentField, _a)) });
            }
            var hasConflict = oppositeField.size > 0;
            currentField.set(option.Id, option);
            var nextOpposite = hasConflict ? new Map() : oppositeField;
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), (_b = {}, _b[fieldName] = currentField, _b[oppositeFieldName] = nextOpposite, _b.filterConflict = hasConflict ? true : state.gamesFilter.filterConflict, _b)) });
        }
        case GamesAction.SHOW_FILTER_CONFLICT:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { filterConflict: true }) });
        case GamesAction.HIDE_FILTER_CONFLICT:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { filterConflict: false }) });
        case GamesAction.CANCEL_FILTERING:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: null, selectedTypes: new Map(), selectedProviders: new Map(), filterConflict: false, providerSortType: 0 }), orderedGames: {
                    isLoading: false,
                    error: null,
                    groups: null,
                    mode: null,
                } });
        case GamesAction.SET_PROVIDER_SORT_TYPE:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { providerSortType: action.payload }) });
        case GamesAction.SEARCH_GAMES:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: true }) });
        case GamesAction.SUCCESS_SEARCH_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, searchedGames: action.data, error: null }) });
        case GamesAction.FAILURE_SEARCH_GAMES:
            return __assign(__assign({}, state), { gamesFilter: __assign(__assign({}, state.gamesFilter), { isLoading: false, error: action.data }) });
        case GamesAction.FETCH_ALL_GAMES:
            return __assign(__assign({}, state), { allGames: __assign(__assign({}, state.allGames), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_ALL_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { allGames: __assign(__assign({}, state.allGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { allGames: __assign(__assign({}, state.allGames), { isLoading: false, games: action.data, error: null }) });
        case GamesAction.FAILURE_FETCH_ALL_GAMES:
            return __assign(__assign({}, state), { allGames: __assign(__assign({}, state.allGames), { isLoading: false, error: action.data }) });
        case GamesAction.PIN_GAME:
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { data: __assign(__assign({}, state.games.data), { Items: state.games.data.Items &&
                            state.games.data.Items.map(function (game) {
                                return game.Id === action.payload.gameId
                                    ? __assign(__assign({}, game), { IsPinned: true }) : game;
                            }) }) }), lobbyGames: __assign(__assign({}, state.lobbyGames), { topGames: state.lobbyGames.topGames &&
                        state.lobbyGames.topGames.map(function (game) {
                            return game.Id === action.payload.gameId
                                ? __assign(__assign({}, game), { IsPinned: true }) : game;
                        }), gameTypes: state.lobbyGames.gameTypes &&
                        state.lobbyGames.gameTypes.map(function (game) {
                            return __assign(__assign({}, game), { Games: game.Games.map(function (gameDetail) {
                                    return gameDetail.Id === action.payload.gameId
                                        ? __assign(__assign({}, gameDetail), { IsPinned: true }) : gameDetail;
                                }) });
                        }) }) });
        case GamesAction.UNPIN_GAME:
            return __assign(__assign({}, state), { games: __assign(__assign({}, state.games), { data: __assign(__assign({}, state.games.data), { Items: state.games.data.Items &&
                            state.games.data.Items.map(function (game) {
                                return game.Id === action.payload.gameId
                                    ? __assign(__assign({}, game), { IsPinned: false }) : game;
                            }) }) }), lobbyGames: __assign(__assign({}, state.lobbyGames), { topGames: state.lobbyGames.topGames &&
                        state.lobbyGames.topGames.map(function (game) {
                            return game.Id === action.payload.gameId
                                ? __assign(__assign({}, game), { IsPinned: false }) : game;
                        }), gameTypes: state.lobbyGames.gameTypes &&
                        state.lobbyGames.gameTypes.map(function (game) {
                            return __assign(__assign({}, game), { Games: game.Games.map(function (gameDetail) {
                                    return gameDetail.Id === action.payload.gameId
                                        ? __assign(__assign({}, gameDetail), { IsPinned: false }) : gameDetail;
                                }) });
                        }) }) });
        case GamesAction.FETCH_RECENT_VISITED_GAMES:
            return __assign(__assign({}, state), { recentVisitedGames: __assign(__assign({}, state.recentGames), { isLoading: true }) });
        case GamesAction.SUCCESS_FETCH_RECENT_VISITED_GAMES:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { recentVisitedGames: __assign(__assign({}, state.recentVisitedGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { recentVisitedGames: __assign(__assign({}, state.recentVisitedGames), { isLoading: false, games: action.data, error: null }) });
        case GamesAction.FAILURE_FETCH_RECENT_VISITED_GAMES:
            return __assign(__assign({}, state), { recentVisitedGames: __assign(__assign({}, state.recentVisitedGames), { isLoading: false, error: action.data }) });
        case GamesAction.OPEN_GAME:
            return __assign(__assign({}, state), { openGame: {
                    error: null,
                    isLoading: true
                } });
        case GamesAction.SUCCESS_OPEN_GAME:
            if (action.data.Code < 0) {
                return __assign(__assign({}, state), { openGame: {
                        isLoading: false,
                        error: action.data.Code
                    } });
            }
            window.location.assign(action.data.LaunchUrl);
            return __assign(__assign({}, state), { openGame: {
                    isLoading: false,
                    error: null,
                } });
        case GamesAction.FAILURE_OPEN_GAME:
            alert(action.data.error.message);
            return __assign(__assign({}, state), { openGame: __assign(__assign({}, state.openGame), { isLoading: false }) });
        case GamesAction.SEARCH_GAMES_BY_PROVIDER:
            return __assign(__assign({}, state), { gamesByProvider: __assign(__assign({}, state.gamesByProvider), { isLoading: true }) });
        case GamesAction.SUCCESS_SEARCH_GAMES_BY_PROVIDER:
            return __assign(__assign({}, state), { gamesByProvider: __assign(__assign({}, state.gamesByProvider), { isLoading: false, error: null, data: action.data }) });
        case GamesAction.FAILURE_SEARCH_GAMES_BY_PROVIDER:
            return __assign(__assign({}, state), { gamesByProvider: __assign(__assign({}, state.gamesByProvider), { isLoading: false }) });
        case GamesAction.FETCH_ORDERED_GAMES:
            return __assign(__assign({}, state), { orderedGames: __assign(__assign({}, state.orderedGames), { isLoading: true, mode: action.mode != null ? action.mode : state.orderedGames.mode }) });
        case GamesAction.SUCCESS_FETCH_ORDERED_GAMES:
            if (action.data && action.data.Code != null && action.data.Code < 0) {
                return __assign(__assign({}, state), { orderedGames: __assign(__assign({}, state.orderedGames), { isLoading: false, error: action.data.Code }) });
            }
            return __assign(__assign({}, state), { orderedGames: {
                    isLoading: false,
                    error: null,
                    groups: action.data ? action.data.Groups : [],
                    mode: action.data ? action.data.Mode : null,
                } });
        case GamesAction.FAILURE_FETCH_ORDERED_GAMES:
            return __assign(__assign({}, state), { orderedGames: __assign(__assign({}, state.orderedGames), { isLoading: false, error: action.data }) });
        case GamesAction.CLEAR_ORDERED_GAMES:
            return __assign(__assign({}, state), { orderedGames: {
                    isLoading: false,
                    error: null,
                    groups: null,
                    mode: null,
                } });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/games/index.js